import React from "react"
import PropTypes from "prop-types"
import TaskRates from "./TaskRates";
import RatesHeader from "./RatesHeader";

class UserTaskClientRates extends React.Component {
  state = { expanded: false }

  toggleExpanded = (expanded) => this.setState({expanded});

  render () {
    const { toggleExpanded } = this;
    const { expanded } = this.state;
    const {
      clientName,
      clients,
      members,
      tasks,
      taskUsers,
      clientTaskUsers,
      handleTaskRate,
      handleClientTaskRate,
      user_rate
    } = this.props;

    return (
      <div>
        {
          tasks && tasks.length > 0 &&
          <div>
            <div className="col-xs-12">
              <div className="space-30" />
            </div>
            <div className="col-xs-12 col-sm-10 col-sm-offset-1">
              <h3>
                Service Specific User Rates
              </h3>
              <RatesHeader showOverride {...{clientName, expanded, toggleExpanded}} />
              {
                (tasks || []).map((task, index) => {
                  const taskUser = taskUsers.find(taskUser => taskUser.task_id == task.id);

                  const useTaskUserRate = taskUser.rate_changed;
                  let rate = useTaskUserRate ? taskUser.rate : task.rate;
                  let billable = useTaskUserRate ? taskUser.billable : task.billable;
                  const override = useTaskUserRate ? taskUser.override : task.override;
                  const showTask = override || expanded;

                  if (user_rate && !taskUser.rate_changed && (!billable || !rate)) {
                    billable = true
                    rate = user_rate
                  }

                  return(
                    showTask ?
                      <TaskRates
                        key={`${index}_${task.id}_${billable}_${rate}`}
                        {...{
                          task,
                          taskUser,
                          clients,
                          members,
                          clientTaskUsers,
                          handleTaskRate,
                          handleClientTaskRate,
                          rate,
                          billable,
                          override,
                          user_rate
                        }}
                      /> : null
                  );
                }
                )
              }
            </div>
          </div>
        }
      </div>
    );
  }
}

UserTaskClientRates.propTypes = {
  clientName: PropTypes.string,
  clients: PropTypes.array,
  tasks: PropTypes.array,
  task_users: PropTypes.array,
  handleTaskRate: PropTypes.func,
  handleClientTaskRate: PropTypes.func,
};
export default UserTaskClientRates
